import { validateFirstName, validateLastName, validateEmail } from '../common';
import { validateDepartment, validateOccupation, validateOccupationOther, validatePhoneNumber, validatePosition, validatePositionOther, } from '../profile';
import { functionalValidate, isRequiredText } from '../utils';
export const clientSeminarValidate = {
    agreement: functionalValidate([
        (value) => (value === true ? '' : 'チェックを入れてください'),
    ]),
    companyName: functionalValidate([isRequiredText('企業名を入力してください')]),
    departmentName: functionalValidate(validateDepartment),
    description: functionalValidate([
        isRequiredText('コメント・要望を入力してください'),
    ]),
    email: functionalValidate(validateEmail),
    firstName: functionalValidate(validateFirstName),
    lastName: functionalValidate(validateLastName),
    occupation: functionalValidate(validateOccupation),
    occupationOther: functionalValidate(validateOccupationOther),
    phone1: functionalValidate(validatePhoneNumber),
    phone2: functionalValidate(validatePhoneNumber),
    phone3: functionalValidate(validatePhoneNumber),
    position: functionalValidate(validatePosition),
    positionOther: functionalValidate(validatePositionOther),
};
export default clientSeminarValidate;
